import { useEffect, useState } from "react";
import { ComplexEntityTypes } from "../../../../../../utils/constants";
import { searchObjectProperties } from "../../../../../../utils/search";
import { useEntities } from "../../../hooks/useEntities";

const useUserById = (entityData) => {
  const { useQueryForEntitiesByType } = useEntities();
  const [user, setUser] = useState(null);

  const { data: users, isLoading } = useQueryForEntitiesByType({
    type: ComplexEntityTypes.USER,
    enabled: entityData?.okta_token_data?.user_id !== undefined,
  });

  useEffect(() => {
    if (users && users.length > 0) {
      const user = users.find(
        (user) =>
          entityData?.okta_token_data?.user_id &&
          searchObjectProperties(user, entityData?.okta_token_data?.user_id)
      );
      setUser(user);
    }
  }, [users, isLoading]);

  return user ? user : null;
};

export const nonHumanIdentityHasTags = (entityData) => {
  if (
    entityData?.tags?.length > 0 ||
    entityData?.aws_common_data?.tags?.length > 0 ||
    entityData?.azure_keyvault_resource_data?.resource_tags?.length > 0 ||
    entityData?.microsoft_entra_id_application_data?.tags?.length > 0
  ) {
    return true;
  } else {
    return false;
  }
};

export const nonHumanIdentityHasHistory = (entityData) => {
  if (
    entityData?.okta_token_data?.creation_datetime ||
    entityData?.aws_common_data?.creation_datetime ||
    entityData?.okta_token_data?.expiration_datetime ||
    entityData?.aws_secret_data?.last_changed_datetime ||
    entityData?.okta_token_data?.last_updated_datetime ||
    entityData?.github_secret_data?.last_updated_date ||
    entityData?.github_secret_data?.creation_date ||
    entityData?.github_pat_data?.created_at ||
    entityData?.azure_keyvault_resource_data?.last_updated_date ||
    entityData?.azure_keyvault_resource_data?.creation_date ||
    entityData?.azure_keyvault_resource_data?.not_before_date ||
    entityData?.azure_keyvault_resource_data?.expiration_date ||
    entityData?.snowflake_service_user?.creation_date ||
    entityData?.snowflake_service_user?.last_success_login ||
    entityData?.snowflake_service_user?.password_last_set_time ||
    entityData?.aws_iam_user_data?.has_console_access ||
    entityData?.mongo_atlas_api_key_data?.last_used ||
    entityData?.atlassian_api_key_data?.last_active_at ||
    entityData?.atlassian_api_key_data?.created_at ||
    entityData?.atlassian_api_key_data?.expires_at ||
    entityData?.atlassian_api_token_data?.created_at ||
    entityData?.atlassian_api_token_data?.expires_at ||
    entityData?.atlassian_api_token_data?.last_active_at ||
    entityData?.zendesk_api_token_data?.created_at ||
    entityData?.zendesk_api_token_data?.last_used ||
    entityData?.microsoft_entra_id_application_data?.created_date ||
    entityData?.gitlab_access_token_data?.last_used_at ||
    entityData?.gitlab_access_token_data?.created_at ||
    entityData?.gitlab_access_token_data?.expires_at ||
    entityData?.github_org_app_data?.created_at ||
    entityData?.github_org_app_data?.updated_at ||
    entityData?.github_org_app_data?.suspended_at ||
    entityData?.salesforce_oauth_token_data?.created_date ||
    entityData?.salesforce_oauth_token_data?.last_used_date ||
    entityData?.slack_saas_nhi_data?.updated ||
    entityData?.claude_api_keys_data?.created_at ||
    entityData?.openai_admin_api_key_data?.created_at ||
    entityData?.openai_admin_api_key_data?.last_used_at ||
    entityData?.microsoft_active_directory_service_user_data?.creation_date ||
    entityData?.microsoft_active_directory_service_user_data
      ?.last_change_date ||
    entityData?.microsoft_active_directory_service_user_data
      ?.last_password_change_date ||
    entityData?.microsoft_active_directory_service_user_data?.last_logon_date
  ) {
    return true;
  } else {
    return false;
  }
};

export const nonHumanIdentityHasCredentials = (entityData) => {
  const appData = entityData?.microsoft_entra_id_application_data;
  return (
    (appData?.password_credentials &&
      Object.keys(appData.password_credentials).length > 0) ||
    (appData?.key_credentials &&
      Object.keys(appData.key_credentials).length > 0)
  );
};

export const getNHIPoliciesRows = (entityData) => {
  let rowsMap = [];

  if (entityData?.aws_common_data?.policy_names) {
    for (const policyName of entityData.aws_common_data.policy_names) {
      if (policyName) {
        // Filter out null/undefined policy names
        rowsMap.push({
          id: rowsMap.length + 1,
          policy_name: policyName,
          source: "aws",
        });
      }
    }
  }

  return rowsMap;
};

export default useUserById;
